export const CURRENCY_FORMATTER = (value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export const CURRENCY_PARSER = (value) => value.replace(/\$\s?|(,*)/g, '')

/**
 * Returns the options for required document types in products
 * @param {Object} flags - Feature flags object from LaunchDarkly
 * @returns {Array} Array of document type options
 * @example
 * getRequiredDocumentOptions({ isProductZipEnabled: true }) // [{ value: 'pdf', label: 'PDF' }, ..., { value: 'zip', label: 'ZIP' }]
 * getRequiredDocumentOptions({}) // [{ value: 'pdf', label: 'PDF' }, { value: 'xml', label: 'XML' }, { value: 'both', label: 'Both' }]
 */
export const getRequiredDocumentOptions = (flags = {}) => {
  const baseOptions = [
    { value: 'pdf', label: 'PDF' },
    { value: 'xml', label: 'XML' },
    { value: 'both', label: 'Both' },
  ]

  return flags?.isProductZipEnabled ? [...baseOptions, { value: 'zip', label: 'ZIP' }] : baseOptions
}
